import { ModuleWithProviders, NgModule, Provider } from '@angular/core';

import { PrimaryNavigationService } from '@priva/appshell';

import { AppPrimaryNavigationService } from './primary-navigation.service';

@NgModule({})
export class NavigationModule {
    static forRoot(): ModuleWithProviders<NavigationModule> {
        return {
            ngModule: NavigationModule,
            providers: [{ provide: AppPrimaryNavigationService, useClass: AppPrimaryNavigationService }],
        };
    }

    static provideDefaultNavigation(): Provider {
        return { provide: PrimaryNavigationService, useExisting: AppPrimaryNavigationService };
    }
}
